<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr','text-align':'right'}">
      <vs-button @click="showRecord()" v-if="!!this.params.data.author_type" class="mt-1 ml-4">詳細 </vs-button>
    </div>
</template>

<script>
import EventBus from '../../EventBus'

export default {
  name: 'CellRendererActions',
  methods: {
    showRecord () {
      EventBus.$emit('showRecord', this.params.data.id)
    },
  },
}
</script>
